import React from 'react';
import ConsultDetail from "../../components/consult/detail/detail";

export default () => {
    return <div><ConsultDetail/></div>
}